<template>
  <div class="mb-5">
    <b-card :title="next.title()" class="mb-5">
      <competition-dates :competition="next" :school="school" :showPayment=true header-class="font-weight-bold pr-5"></competition-dates>
    </b-card>

    <h4>Aktuelle Wettbewerbe</h4>
    <current-table v-bind:items="currentCompetitions"></current-table>

    <h4 class="mt-5">Beendete Wettbewerbe</h4>
    <ended-table :school="school" :competitions="endedCompetitions"></ended-table>
  </div>
</template>

<script>
import {Competition, CompetitionRegistration as Registration} from '@/models'
import CompetitionDates from '@/components/competitions/DatesTable'
import CurrentTable from '@/components/dashboard/CurrentTable'
import EndedTable from '@/components/dashboard/EndedTable'

export default {
  name: 'Dashboard',
  components: {
    competitionDates: CompetitionDates,
    currentTable: CurrentTable,
    endedTable: EndedTable
  },

  data () {
    let next = new Competition({id: 'current'})

    return {
      header: 'Übersicht',
      next: next,
      school: this.$parent.getSchool(),
      currentCompetitions: [],
      endedCompetitions: []
    }
  },

  mounted () {
    this.$eventHub.$emit('alertHide')

    if (this.$route.params.from) {
      this.switchAlert(this.$route.params.from)
    }

    if (this.$parent.isUser() && this.$parent.getSchool() === null) {
      this.$router.push({name: 'teacher.settings.school', params: {from: 'registration'}})
    }

    this.next.fetch()
    this.loadCompetitions()
  },

  methods: {
    loadCompetitions: function () {
      this.axios.get('/users/me/competitions')
        .then(rsp => {
          if (!rsp || !rsp.data) {
            return
          }

          rsp.data.forEach(row => {
            let competition = new Competition(row.competition)

            let registration = new Registration()
            if (row.registration) {
              registration = new Registration(row.registration)
            }

            let item = {
              competition: competition,
              registration: registration,
              payment: registration ? registration.payment : null,
              route: {
                name: 'teacher.competition.details',
                params: {id: competition.id}
              }
            }

            if (registration.registered()) {
              item.route.query = {id: registration.id}
            }

            if (item.competition.prices) {
              this.endedCompetitions.push(item)
            } else {
              this.currentCompetitions.push(item)
            }
          })
        })
    },

    switchAlert: function (from) {
      let msg
      switch (from) {
        case 'registration':
          msg = 'Anmeldung erfolgreich gespeichert'
          break
        case 'settings.school.success':
          msg = 'Änderungen erfolgreich gespeichert'
          break
        case 'passwordReset':
          msg = 'Passwort erfolgreich aktualisiert. Willkommen zurück!'
          break
        default:
          return
      }

      this.$eventHub.$emit('alertInfo', msg)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/users/Dashboard.vue